import _defineProperty from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var variationOne = {
  className: 'text-card',
  ariaLabel: 'Text Card',
  headingText: 'Your Pet, Our Priority',
  descriptionType: 'RichText',
  descriptionText: {
    data: {},
    content: [{
      data: {},
      content: [{
        data: {},
        marks: [],
        value: 'Lorem ipsum dolor sit amet,magna.',
        nodeType: 'text'
      }],
      nodeType: 'paragraph'
    }, {
      data: {},
      content: [{
        data: {},
        marks: [],
        value: 'Maecenas mi urna, efficitur sit ametVestibulum ut magna metus.',
        nodeType: 'text'
      }],
      nodeType: 'paragraph'
    }],
    nodeType: 'document'
  },
  buttonText: 'Action'
};
var variationTwo = {
  className: 'text-card',
  ariaLabel: 'Text Card',
  headingText: 'Your Pet, Our Priority',
  descriptionType: 'RichText',
  descriptionText: {
    data: {},
    content: [{
      data: {},
      content: [{
        data: {},
        marks: [],
        value: 'Lorem ipsum dolor sit amet,magna.',
        nodeType: 'text'
      }],
      nodeType: 'paragraph'
    }, {
      data: {},
      content: [{
        data: {},
        marks: [],
        value: 'Maecenas mi urna, efficitur sit ametVestibulum ut magna metus.',
        nodeType: 'text'
      }],
      nodeType: 'paragraph'
    }],
    nodeType: 'document'
  }
};
var variationThree = {
  className: 'text-card',
  ariaLabel: 'Text Card',
  headingText: 'Your Pet, Our Priority',
  buttonText: 'Action'
};
var data = {
  ariaLabel: 'Text Card',
  headingText: 'Text Card Heading',
  subHeadline: 'Sub Headline',
  subHeadingText: 'Sub Heading Text',
  headingTypeSubHeading: 'h3',
  descriptionType: 'RichText',
  descriptionText: {
    data: {},
    content: [{
      data: {},
      content: [{
        data: {},
        marks: [],
        value: 'Lorem ipsum dolor sit amet,magna.',
        nodeType: 'text'
      }],
      nodeType: 'paragraph'
    }, {
      data: {},
      content: [{
        data: {},
        marks: [],
        value: 'Maecenas mi urna, efficitur sit ame. Vestibulum ut magna metus.',
        nodeType: 'text'
      }],
      nodeType: 'paragraph'
    }],
    nodeType: 'document'
  }
};
var textCardMock1 = _objectSpread(_objectSpread({}, data), {}, {
  className: 'text-card',
  buttonText: 'Action',
  cta: {
    label: 'Find a Resort',
    url: '#'
  },
  isAlreadyWraped: false
});
var textCardMock2 = _objectSpread(_objectSpread({}, data), {}, {
  className: 'text-card',
  buttonText: 'Action',
  cta: {
    label: 'Find a Resort',
    url: '#'
  },
  isAlreadyWraped: true
});
var textCardMock3 = _objectSpread(_objectSpread({}, data), {}, {
  className: 'hero-carousel variation-a',
  buttonText: 'Action',
  cta: {
    label: 'Find a Resort',
    url: '#',
    title: 'LINK - PetSuites of America 0819 - /locations - [Find a Resort]',
    styleType: 'hero-button'
  },
  styleType: 'heroCarousel',
  fontColor: 'Light',
  isHero: true
});
var textCardMock4 = _objectSpread(_objectSpread({}, data), {}, {
  className: 'hero-carousel variation-b',
  buttonText: 'Action',
  cta: {
    label: 'Find a Resort',
    url: '#',
    title: 'LINK - PetSuites of America 0819 - /locations - [Find a Resort]',
    styleType: 'hero-button'
  },
  styleType: 'heroCarousel',
  fontColor: 'Dark',
  isHero: true
});
export { variationOne, variationTwo, variationThree, textCardMock1, textCardMock2, textCardMock3, textCardMock4 };